import React, { useEffect, useState } from "react";
import { listAdminUsers } from "@/services/admin.service";
import { fmtDate } from "@/lib/format";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => { try { setUsers(await listAdminUsers()); } finally { setLoading(false); } })(); }, []);
  return (
    <div className="space-y-6" data-testid="admin-users-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">Admin</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">Users</h1>
      </div>
      <div className="bg-card border border-border rounded-xl overflow-x-auto">
        {loading ? <div className="p-12 text-center text-muted-foreground">Loading…</div> : (
          <table className="w-full text-sm">
            <thead className="bg-secondary/40 text-muted-foreground text-xs uppercase tracking-widest">
              <tr>
                <th className="text-left px-6 py-3 font-semibold">Name</th>
                <th className="text-left px-6 py-3 font-semibold">Email</th>
                <th className="text-left px-6 py-3 font-semibold">Role</th>
                <th className="text-left px-6 py-3 font-semibold">Provider</th>
                <th className="text-left px-6 py-3 font-semibold">Joined</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {users.map((u) => (
                <tr key={u.user_id} className="hover:bg-secondary/30">
                  <td className="px-6 py-3 font-medium">{u.name}</td>
                  <td className="px-6 py-3 text-muted-foreground">{u.email}</td>
                  <td className="px-6 py-3"><span className="px-2 py-0.5 rounded-full bg-secondary text-xs font-semibold capitalize">{u.role}</span></td>
                  <td className="px-6 py-3 text-muted-foreground capitalize">{u.auth_provider}</td>
                  <td className="px-6 py-3 text-muted-foreground">{fmtDate(u.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminUsers;
